"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports.default = void 0;

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _focusWithoutScrolling = _interopRequireDefault(require("../../utils/focusWithoutScrolling"));

var _assignRef = _interopRequireDefault(require("../../utils/assignRef"));

var _OptionsList = _interopRequireDefault(require("../../atoms/OptionsList"));

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledMenu = (0, _styledComponents.default)(_OptionsList.default).withConfig({
  displayName: "Menu__StyledMenu",
  componentId: "kr6c2h-0"
})(["cursor:default;display:flex;flex-direction:column;margin:0;max-height:60vh;max-width:", ";overflow-x:hidden;overflow-y:auto;padding:0;&:focus{outline:none;}&& > div,&& > a{list-style-type:none;margin:0;padding:", ";}"], (0, _rem.default)(340), "".concat((0, _rem.default)(7), " ").concat((0, _rem.default)(30), " ").concat((0, _rem.default)(7), " ").concat((0, _rem.default)(10)));

var Menu = function Menu(props, _ref) {
  var _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      onSelectItem = props.onSelectItem,
      allowTab = props.allowTab,
      actions = props.actions;

  var _useMemo = (0, _react.useMemo)(function () {
    return items.reduce(function (acc, value) {
      var label = value.text,
          icon = value.icon,
          onSelect = value.onSelect,
          rest = _objectWithoutProperties(value, ["text", "icon", "onSelect"]);

      return {
        itemsMap: _objectSpread({}, acc.itemsMap, _defineProperty({}, value.id, value)),
        optionsListItems: [].concat(_toConsumableArray(acc.optionsListItems), [_objectSpread({}, rest, {
          label: label
        }, icon && {
          decoration: {
            type: 'Icon',
            icon: icon
          }
        })])
      };
    }, {
      optionsListItems: [],
      itemsMap: {}
    });
  }, [items]),
      optionsListItems = _useMemo.optionsListItems,
      itemsMap = _useMemo.itemsMap;

  var listRef = (0, _react.useRef)(null); // return focus(when unmounted) to the element that had it when Menu was mounted

  (0, _react.useEffect)(function () {
    var _document = document,
        activeElement = _document.activeElement;
    return function () {
      if (activeElement) {
        activeElement.focus();
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    listRef.current && (0, _focusWithoutScrolling.default)(listRef.current);
  }, [listRef]);
  var onChange = (0, _react.useCallback)(function (id) {
    var item = itemsMap[id];
    item.onSelect && item.onSelect();
    onSelectItem && onSelectItem(item);
  }, [itemsMap, onSelectItem]);
  var onKeyDown = (0, _react.useCallback)(function (event) {
    if (event.key === 'Tab' && !allowTab) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, [allowTab]);
  return _react.default.createElement(StyledMenu, {
    actions: actions,
    items: optionsListItems,
    selectable: false,
    multiple: false,
    role: "menu",
    itemRole: "menuitem",
    name: "menu",
    ref: function ref(ul) {
      _ref && (0, _assignRef.default)(_ref, ul);
      (0, _assignRef.default)(listRef, ul);
    },
    onChange: onChange,
    onKeyDown: onKeyDown
  });
};

var MenuWithRef = (0, _react.forwardRef)(Menu); // @ts-ignore

MenuWithRef.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired,
    icon: _propTypes.default.elementType,
    linkTo: _propTypes.default.string,
    disabled: _propTypes.default.bool,
    onSelect: _propTypes.default.func
  })).isRequired,
  onSelectItem: _propTypes.default.func,
  allowTab: _propTypes.default.bool
};
MenuWithRef.defaultProps = {
  allowTab: false
};
var _default = MenuWithRef;
exports.default = _default;